import React, { useState } from 'react'
import moment from 'moment';
import queryString from 'query-string';
import NumberFormat from 'react-number-format';

export default function SearchComponent({ history, location }) {
  const queryParams = queryString.parse(location.search);
  const page = queryParams.page || 1;

  const [lastName, setLastName] = useState(queryParams.lastName || '');
  const [firstName, setFirstName] = useState(queryParams.firstName || '');
  const [dateOfBirth, setDateOfBirth] = useState(queryParams.dateOfBirth || '');
  const [invalidDate, setInvalidDate] = useState(false);

  const handleSearch = () => {
    if (dateOfBirth && dateOfBirth.replace(/\D/g, '').length !== 8) {
      setInvalidDate('Invalid format: Ex: 03/15/1980.');
    } else if (dateOfBirth && !moment(dateOfBirth, 'MM/DD/YYYY').isValid()) {
      setInvalidDate('Date of Birth is not valid.');
    } else {
      setInvalidDate(false);
      history.replace(`/messages/send?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}`);
    }
  }

  const handleClear = () => {
    setLastName('')
    setFirstName('')
    setDateOfBirth('')
    history.replace(`/messages/send`)
  }

  return <form className=" w-100">
    <div className="row">
      <div className="form-group col-12 col-lg-3">
        <input
          id="first-name"
          type="text"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
          className="form-control"
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleSearch()
          }}
          placeholder="First Name"
        />
      </div>

      <div className="form-group col-12 col-lg-3">
        <input
          id="last-name"
          type="text"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
          className="form-control"
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleSearch()
          }}
          placeholder="Last Name"
        />
      </div>

      <div className="form-group col-12 col-lg-3">
        <NumberFormat
          mask="_"
          value={dateOfBirth || ''}
          name="dateOfBirth"
          format="##/##/####"
          className={`form-control ${invalidDate ? 'is-invalid' : ''}`}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleSearch()
          }}
          placeholder="Date of Birth"
          onValueChange={(e) => setDateOfBirth(e.formattedValue)}
        />
      </div>

      <div className="form-group col-12 col-lg-3">
        <button onClick={handleSearch} type="button" className="btn btn-primary mr-2">Search</button>
        <button onClick={handleClear} type="button" className="btn btn-outline-primary">Clear</button>
      </div>
    </div>
  </form>
}
